@if (isDisplay()) {
  @if ({ isMobile: (isMobileLayout$ | async) }; as layoutState) {
    <button class="button-help__button"
      [attr.aria-label]="layoutState.isMobile ? ('generic.help.modal_page' | translate) : null"
      [matTooltip]="layoutState.isMobile ? ('generic.help.modal_page' | translate) : null"
      (click)="openHelpContent()">
      @if (!layoutState.isMobile) {
        <span>{{ 'generic.help.modal_page' | translate }}</span>
      }
      <mat-icon svgIcon="button-help__support"></mat-icon>
    </button>
  }
}